import initCompanyAutocompleteOnFocus from './initCompanyAutocompleteOnFocus';

const input = document.querySelector('input[name="company_name"]');
const inputId = document.querySelector('input[name="company_id"]');

if (input && inputId) {
  initCompanyAutocompleteOnFocus(input, inputId);
}
